import { render } from "./adminSidebar.vue?vue&type=template&id=6eb93338"
import script from "./adminSidebar.vue?vue&type=script&lang=js"
export * from "./adminSidebar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TECHNOVA_FD01\\Desktop\\Augustine\\Projects\\XP\\payout-fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__